<div class="main-content">
    <div class="header-options">
        <div class="tem-field header-field" *ngIf="uid.user.companylist.length > 1">
            <span class="tem-field-label">{{'correios.company'|translateTA}}</span>
            <nz-select [(ngModel)]="codecompany" nzShowSearch
                       [nzPlaceHolder]="'correios.company'|translateTA"
                       (ngModelChange)="onCompanyChange($event)">
                <nz-option *ngFor="let data of uid.user.companylist"
                           [nzValue]="data.codecompany"
                           [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
            </nz-select>
        </div>

        <div class="tem-field header-field">
            <span class="tem-field-label">{{'correios.services'|translateTA}}</span>
            <nz-select [(ngModel)]="servico" nzShowSearch nzAllowClear
                       [nzPlaceHolder]="'correios.selectService'|translateTA"
                       [nzDisabled]="listServices.length==0">
                <nz-option *ngFor="let data of listServices"
                           [nzValue]="data"
                           [nzLabel]="data.codigo + ' - ' + data.descricao"></nz-option>
            </nz-select>
        </div>
    </div>

    <div class="grid-content" [ngClass]="{disabled: !enablePanels}">
        <div class="panel-grid">
            <div class="tem-card">
                <div class="tem-card__header">
                    <span class="tem-card__title">{{'correios.availability.title'|translateTA}}</span>
                </div>
                <div class="tem-card__body">
                    <cep-disponibilidade [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico"></cep-disponibilidade>
                </div>
            </div>

            <cep-consultapreco [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico" [eventUserConfig]="eventsSubject.asObservable()"></cep-consultapreco>

            <cep-buscaobjeto [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico" [eventUserConfig]="eventsSubject.asObservable()"></cep-buscaobjeto>

            <div class="tem-card span-2">
                <div class="tem-card__header">
                    <span class="tem-card__title">{{'correios.tracking.title'|translateTA}}</span>
                </div>
            </div>

            <cep-range [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico" [eventUserConfig]="eventsSubject.asObservable()"></cep-range>
        </div>
    </div>
</div>
